const ROUTES = {
  "/": {
    "name": "HomePage9aab17011b8c4cab90f7Bcbdc7918da4",
    "type": "HTML",
    "key": "home-page"
  },
  "/about": {
    "name": "AboutUsPage58d47d1269e046508f0dC15ddbe20f49",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/apply/*": {
    "name": "ApplicationPagesF20f06b9234349adBfed5671dc839353",
    "type": "REFERENCE",
    "key": "application-pages"
  },
  "/contact": {
    "name": "ContactE6bbe341457946609411168171d86728",
    "type": "HTML",
    "key": "contact"
  },
  "/events/public": {
    "name": "PublicEventsPage4f47a748Ff8c4496B95dA7848d19c114",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage5d0a8344C51543d2Acdd4f884f60011d",
    "type": "REFERENCE",
    "key": "join-us-page"
  },
  "/meetings": {
    "name": "MeetingsPageD31e9c96Af8b40cb92486461f3735ef7",
    "type": "HTML",
    "key": "meetings-page"
  }
};

export default ROUTES;